import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';
import './order.css';
import { useSpring, animated } from 'react-spring';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

function Order(props) {
    const fade = useSpring({ opacity: 1, from: { opacity: 0 } });

  const classes = useStyles();
  console.log(props.orderItem, 'props.orderItem');
  return (
    <div className="order">
      <div>
        <CurrencyFormat
          renderText={(value) => (
            <h5 className="order__total">Order Total: {value}</h5>
          )}
          decimalScale={2}
          value={parseInt(props.orderItem?.amount) / 100}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      </div>
      <div className="order_content">
        {props.orderItem.Basket.map((item) => {
          return (
            <animated.div d style={fade}>
              <div>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={item.image}
                      title={item.title}
                    />
                    <CardContent>
                      {item.title}

                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Price :2000
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </div>
            </animated.div>
          );
        })}
      </div>
      <div>
        <h5 className="order__total">Order Total: {props.orderItem.id}</h5>
      </div>
    </div>
  );
}

export default Order;
